import { useModuleBEM } from "@b2bportal/core-themes";
import { Section } from "../Section";
import styles from "./HomepagePerksSection.module.scss";
import {
  EarnPointsDialog,
  ExclusiveRatesDialog,
  LowestRateDialog,
} from "@/components/PerkDialogs";

export const HomepagePerksSection = () => {
  const [block, cn] = useModuleBEM(styles, "HomepagePerksSection");
  return (
    <Section className={block}>
      <div className={cn("content")}>
        <EarnPointsDialog />
        <ExclusiveRatesDialog />
        <LowestRateDialog />
      </div>
    </Section>
  );
};
